export const login = (state = { userRole: "", token: "", user: "", userName: "", error: "" }, action) => {
  switch (action.type) {
    case "LOGIN_WITH_EMAIL": {
      if (!action.payload.success) return { ...state, error: action.payload }
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('expiration', action.payload.expiration);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('userRole', action.payload.userRole);
      return { ...state, userRole: action.payload.userRole, token: action.payload.token, user: action.payload.user, userName: "", error: "" }
    }   
    case "LOGIN_TWO_FACTOR": {
      if (!action.payload.success) return { ...state, error: action.payload }
      //localStorage.setItem('user', JSON.stringify(action.payload.user));
      return { ...state, /*userName: action.payload.user.userName,*/ error: "" }
    }    
    case "LOGOUT_WITH_EMAIL":
    case "LOGOUT_WITHOUT_EMAIL": {
      localStorage.removeItem('token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      return { ...state, userRole: "", token: "", user: "", userName: "", error: "" }
    }
    case "CHANGE_ROLE": {
      localStorage.setItem('userRole', action.userRole);
      return { ...state, userRole: action.userRole }
    }
    case "CHANGE_PASSWORD": {
      if (!action.payload.success) return { ...state, error: action.payload }
      return { ...state, error: "" }
    }
    case "CHANGE_USER": {
      localStorage.setItem('user', JSON.stringify(action.user));
      return {...state, user: action.user}
    }
    case "REFRESH_TOKEN": {
      if (!action.payload.success) return { ...state, error: action.payload }
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('expiration', action.payload.expiration);
      return { ...state, token: action.payload.token, error: "" }
    }  
    default: {
      return state
    }
  }
}
